import { saveAs } from 'file-saver';

export class CommonHandler {
  public static getCopy(object: any): any {
    if (object) {
      return JSON.parse(JSON.stringify(object));
    }
    return undefined;
  }

  public static loadScript(id: string, src: string, tag: string = 'head') {
    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.type = 'text/javascript';
    script.async = true;
    script.charset = 'utf-8';
    document.getElementsByTagName(tag)[0].appendChild(script);
  }

  public static unloadScript(id: string) {
    const script = document.getElementById(id);
    if (script) {
      script.remove();
    }
  }

  public static isEmpty(obj: any) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  public static getCurrentYear(): number {
    return new Date().getFullYear();
  }

  public static getCurrentMonthNumber(): number {
    return new Date().getMonth() + 1;
  }

  public static getCurrentMonthName(): string {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return monthNames[new Date().getMonth()];
  }

  public static getCurrentMonthShortName(): string {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sepr', 'Oct', 'Nov', 'Dec'];
    return monthNames[new Date().getMonth()];
  }

  public static getMonthNumber(m: string): number {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months.findIndex((month) => month === m) + 1;
  }

  public static getMonthNumberForShortName(m: string): number {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months.findIndex((month) => month === m) + 1;
  }

  public static getMonthName(monthNumber: number): string {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return months[monthNumber - 1];
  }

  public static getYYYYMMDD(d: any) {
    const yyyy = d.getFullYear().toString();
    const mm = (d.getMonth() + 101).toString().slice(-2);
    const dd = (d.getDate() + 100).toString().slice(-2);
    return `${yyyy}-${mm}-${dd}`;
  }

  public static calcPercentage(list: number[] = [], startYearIndex = 0) {
    if (list.length == 0) return 0;
    return ((list[list.length - 1] - list[startYearIndex]) / list[startYearIndex]) * 100;
  }

  public static downloadBlobFile(res, inputDocType, outputDocType, filename) {
    let blob = new Blob([res], { type: this.createFileType(inputDocType) });
    const file = new File([blob], filename, { type: this.createFileType(outputDocType) });
    saveAs(file);
  }

  public static createFileType(e): string {
    let fileType: string = '';
    if (e == 'pdf' || e == 'csv') {
      fileType = `application/${e}`;
    } else if (e == 'jpeg' || e == 'jpg' || e == 'png') {
      fileType = `image/${e}`;
    } else if (e == 'txt') {
      fileType = 'text/plain';
    } else if (e == 'ppt' || e == 'pot' || e == 'pps' || e == 'ppa') {
      fileType = 'application/vnd.ms-powerpoint';
    } else if (e == 'pptx') {
      fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    } else if (e == 'doc' || e == 'dot') {
      fileType = 'application/msword';
    } else if (e == 'docx') {
      fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else if (e == 'xls' || e == 'xlt' || e == 'xla') {
      fileType = 'application/vnd.ms-excel';
    } else if (e == 'xlsx') {
      fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (e == 'zip') {
      fileType = 'application/zip';
    }

    return fileType;
  }

  // Generate a unique string
  public static generateUniqueString(prefix = ''): string {
    const timestamp = Date.now().toString(36).toUpperCase(); // Convert to base-36
    const randomStr = Math.random().toString(36).substring(2, 8).toUpperCase(); // Random string
    return `${prefix}${timestamp}${randomStr}`;
  }

  public static extractYearQuarter(timeline: string) {
    const MONTH_QUARTER_MAPPING = { '01': 'Q1', '04': 'Q2', '07': 'Q3', '10': 'Q4' };
    const [year, month] = timeline.split('-');
    return MONTH_QUARTER_MAPPING[month] + ' ' + year;
  }
}
